module.exports = __webpack_public_path__ + "media/images/default/pay_services/4-0d763687ec5d181c394d0f136e9d7d34.jpg";